<template>
    <div class="main-check-work">
        <div class="check-work">
            <div class="activity-menus">
                <ul>
                    <li :class="activeName == 1?'active':''" @click="handleClick(1)">认证中心验证</li>
                    <li :class="activeName == 2?'active':''" @click="handleClick(2)">公证处证书验证</li>
                </ul>
            </div>

            <div class="check-content">
                <div class="left-setup">
                    <li class="setup-li">
                        <label class="setup-icon">
                            <img src="@/assets/images/setup-1.png" width="100%"/>
                        </label>
                        <label class="setup-name">
                            验证成功
                        </label>
                    </li>
                    <li class="line-li">
                        <div></div>
                        <div></div>
                    </li>
                    <li class="setup-li">
                        <label class="setup-icon">
                            <img src="@/assets/images/setup-1.png" width="100%"/>
                        </label>
                        <label class="setup-name">
                            点击验证
                        </label>
                    </li>
                    <li class="line-li">
                        <div></div>
                        <div></div>
                    </li>
                    <li class="setup-li">
                        <label class="setup-icon">
                            <img src="@/assets/images/setup-1.png" width="100%"/>
                        </label>
                        <label class="setup-name">
                            输入编号
                        </label>
                    </li>
                    <li class="line-li">
                        <div></div>
                        <div></div>
                    </li>
                    <li class="setup-li">
                        <label class="setup-icon">
                            <img src="@/assets/images/setup-2.png" width="100%"/>
                        </label>
                        <label class="setup-name" style="color: rgb(255,255,255,0.3);">
                            Loading
                        </label>
                    </li>

                    <div class="check-desc">
                        <p>1.证书查验是提供给您获取当前作品权利的凭证  </p><br/>
                        <p>2.需要验证证书的有效性则输入证书编号即可，验证成功后展示文件信息和证书信息;</p><br/>
                        <p>3.需要验证证书且查看此证书对应的原文件，则必须要上传原文件，进行原文件校验</p>
                    </div>
                    
                </div>
                <div class="check-info">
                    <div class="form-item">
                        <label class="cert-item-name"><font style="color: red;">*</font>证书编号</label>
                        <label style="flex: 1;">
                            <el-input v-model="certNo" size="small" placeholder="请输入需要验证的证书编号"> </el-input> 
                        </label>
                    </div>
                    <div class="upload-work">
                        <el-upload
                            :file-list="fileList"
                            action="" 
                            :auto-upload="false"
                            drag
                            :on-exceed="onExceed"
                            :on-change="onChange"
                            :limit="1"
                            multiple>
                            <div class="upload-drag">
                                <img src="@/assets/images/Vector.png"/>
                                <p>拖拽您的文件到这里或者从计算机上传</p>
                                <div class="iconc">
                                    <img src="@/assets/images/check-work-upload.png" width="100%"/>
                                </div>
                            </div>
                        </el-upload>
                    </div>
                    <div class="check-btn">
                        <el-button type="primary" @click="check">点击验证</el-button>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { checkWork } from '@/api/business'
    import router from '@/router';
    import CryptoJS from 'crypto-js';
     export default {
        name:'check-work',
        components:{
        },
        data () {
            return { 
                activeName:1, 
                certNo:"",
                fileHash:"",
                fileList:[]
            }
        },
        mounted() {
        //    this.init()
        },
        methods: {
            handleClick(key){
                if(key == 1){
                    // this.activityTypes = 'activityTrain,trainNotice';
                    // this.init();
                    this.activeName = key;
                }else if(key == 2){
                    // this.activityTypes = 'activityReport,trainReport';
                    // this.init();
                    // http://36.110.223.37:13011/#/verification
                    window.open("http://36.110.223.72:13011/#/verification","_target");
                }
                
            },
            onExceed(files, fileList){
                console.log("onExceed",files, fileList);
                this.fileList = [files[0]];
                this.uploadHash(files[0]);
            },
            onChange(file, fileList){
                console.log("onChange",file, fileList);
                this.uploadHash(file.raw);
            },
            
            beforeUpload(file){
                // console.log("beforeUpload",file);
                // // this.countFileHash(files.raw);

                // const reader = new FileReader();
                // reader.onload = (e) => {
                //     const binary = e.target.result;
                //     this.countFileHash(binary);
                // // 在这里可以做其他的处理，例如将hash值发送到服务器验证
                // };

                // reader.readAsArrayBuffer(file.raw);
                // return false;

            },
            computeHash(binary) {
                
                const uint8 = new Uint8Array(binary);
                const wordArray = CryptoJS.lib.WordArray.create(uint8)
                const hash = CryptoJS.SHA256(wordArray).toString()
                this.fileHash = hash;
                console.log("hash",hash);
                return hash;
            },
            check(){
                if(!this.certNo){
                    this.$message({
                        showClose: true,
                        message: '证书编号必须填写',
                        type: 'warning'
                    });
                    return false;
                }
                checkWork({copyrightRegisterAuthCertNo:this.certNo,copyrightRegisterHash:this.fileHash}).then(res=>{
                    console.log("check",res);
                    if(res.code == 200){
                        router.push({
                            path:"/work/check/success",
                            query:{
                                certNo:this.certNo,
                                fileHash:this.fileHash
                            }
                        });
                    }else{
                        router.push({
                            path:"/work/check/error",
                            query:{
                                certNo:this.certNo,
                                fileHash:this.fileHash
                            }
                        });
                    }
                    this.fileHash = null;
                    this.fileList = [];
                })
            },
            uploadHash(file){
                const reader = new FileReader();
 
                reader.onload = (e) => {
                    const binary = e.target.result;
                    this.computeHash(binary);
                // 在这里可以做其他的处理，例如将hash值发送到服务器验证
                };
                reader.readAsArrayBuffer(file);
            }
        }
     }
</script>

<style lang="less" scoped>
.main-check-work{
    margin-top: 68px;
    text-align: left;
    .check-work{
        width: 1200px;
        margin: 0 auto;
        padding-top: 30px;

        .activity-menus{
            height: 50px;
            font-size: 22px;
            border-bottom: 2px solid #EFEFEF;
            ul{
                display: flex;
                justify-content: center;
                user-select: none;
            }
            ul li{
                padding: 0 30px;
                color: #999;
                position: relative;
                cursor: pointer;
                height: 50px;
            }
            ul li.active{
                color: #333 !important;
                font-weight: 600;
            }
        }
        .check-content{
            height: 668px;
            display: flex;
            margin-top: 10px;
            box-sizing: border-box;
            .left-setup{
                width: 433px;
                height: 100%;
                background-color: #569FE8;
                box-sizing: border-box;
                padding-top: 80px;
                padding-left: 50px;
                user-select: none;
                .setup-li{
                    display: flex;
                    width: 120px;
                    justify-content: space-between;
                    align-items: center;
                    font-size: 14px;
                    font-weight: 400;
                    .setup-icon{
                        width: 26px;
                        height: 26px;
                    }
                    .setup-name{
                        color: #fff;
                        width: 60px;
                        text-align: left;
                    }
                }
                .line-li{
                    height: 30px;
                    width: 120px;
                    position: relative;
                    padding-left: 12px;
                    div{
                        width: 3px;
                        height: 5px;
                        background-color: #fff;
                        margin-top: 8px;
                    }
                }
                .check-desc{
                    width: 309px;
                    height: 200px;
                    border-radius: 8px;
                    background-color: #fff;
                    margin-top: 80px;
                    position: relative;
                    background-image: url("@/assets/images/Intersect.png");
                    background-repeat: no-repeat;
                    background-size: 192px 43px;
                    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
                    font-size: 12px;
                    font-family: 'PingFang SC';
                    padding: 36px 23px;
                    box-sizing: border-box;
                    p{
                        color: #666666; 
                        line-height: 20px;
                    }
                }
                .check-desc::after{

                    content: "";
                    width: 53px;
                    height: 48px;
                    position: absolute;
                    display: flex;
                    background-image: url("@/assets/images/setup-3.png");
                    left: -25px;
                    top: -25px;
                }

                
            }
            .check-info{
                flex: 1;
                padding: 120px 68px;
                .form-item{
                    display: flex;
                    .cert-item-name{
                        width: 80px;
                        line-height: 32px;
                    }
                }
                .upload-work{
                    margin-top: 50px;
                    .upload-drag{
                        width: 630px;
                        height: 219px;
                        border: 1px dashed #569FE8;
                        border-radius: 6px;
                        background-color: #F7FBFF;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        position: relative;
                        p{
                            color: #A9D1F6;
                            font-size: 12px;
                            margin-top: 20px;
                        }
                        .iconc{
                            position: absolute;
                            right: 40px;
                            bottom: 40px;
                            width: 43px;
                            height: 43px;
                        }
                    }
                }
                .check-btn{
                    padding: 80px 0;
                    text-align: center;
                }
                
            }
        }

    }
}
    
</style>
<style>
    .upload-work .el-upload-dragger{
        width: auto;
        height: auto;
        border: 0;
    }
</style>